import { render, staticRenderFns } from "./FooterSupport.vue?vue&type=template&id=384ce581&scoped=true&lang=pug&"
import script from "./FooterSupport.vue?vue&type=script&lang=js&"
export * from "./FooterSupport.vue?vue&type=script&lang=js&"
import style0 from "./FooterSupport.vue?vue&type=style&index=0&id=384ce581&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384ce581",
  null
  
)

export default component.exports